module.exports = __webpack_public_path__ + "img/secure-video-2.66e897f3.jpg";